import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import userContext from '../context/Users/UserContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import noteContext from '../context/Notes/NoteContext';

const Navbar = (props) => {

    const navigate = useNavigate();

    const [islogeedin, setislogeedin] = useState(false)

    const context = useContext(userContext);
    const { isauthenticated, setisauthenticated } = context

    const ntcontext = useContext(noteContext)
    const { authtoken,setauthtoken} = ntcontext


    const handlelogout = () => {

        setauthtoken("");
        localStorage.removeItem("token");
        props.showalert("Logged out successfully","success");
        navigate("/login")
        setisauthenticated(false);
        navigate('/');
    }


    let location = useLocation();

    useEffect(() => {

    }, [location])

    return (
        <>
            <nav className="navbar navbar-expand-lg shadow">
                <div className="container-fluid">
                    <Link className="navbar-brand " to="">EverFloatNotes</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse " id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <Link className={`nav-link ${isauthenticated?"":"d-none"}   ${location.pathname == "/home" ? "active" : ""}`} to="/home">Dashboard</Link>
                            </li>
                            <li className="nav-item">
                                <Link className={`nav-link ${location.pathname == "/about" ? "active" : ""}`} to="/about">About</Link>
                            </li>
                        </ul>
                        <Link className={`btn btn-dark mx-1 d-${isauthenticated ? "none" : ""}`} to="/login" role="button">Login</Link>
                        <Link className={`btn btn-dark mx-1 d-${isauthenticated ? "none" : ""}`} to="/signup" role="button">SignUp</Link>
                        <Link className={`btn btn-dark mx-1 d-${!isauthenticated ? "none" : ""}`} to="/" role="button" onClick={handlelogout}>Logout</Link>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Navbar